import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Labels } from 'src/app/app.models';

@Component({
    selector: 'app-custom-radio-input',
    templateUrl: './custom-radio-input.component.html',
    styleUrls: ['./custom-radio-input.component.scss'],
    standalone: false
})
export class CustomRadioInputComponent {
  @Output() optionSelectEvent: EventEmitter<any> = new EventEmitter<any>() // Todo: type
  
  @Input() labels: Labels
  @Input() optionConfig: any // Todo: type
  @Input() selectedOptionId: any // Todo: type
  @Input() isFormMode: boolean = false

  public emitSelectedOption(selectedOption: any): void {
    this.optionSelectEvent.emit(selectedOption)
  }
}
